import React from "react"
import "./sex.less"

export default function({ values }) {
  let [male = 0, female = 0] = values
  let per_male = 0
  let per_female = 0
  let sum = male + female
  if (sum > 0) {
    per_male = parseInt((male / sum) * 100)
    per_female = 100 - per_male
  }
  let male_ratio = per_male / 10
  let female_ratio = per_female / 10
  return (
    <div className="sexList">
      <div className="manList">
        <span className="num" id="man-pie">
          {per_male}%
        </span>
        {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(d => {
          let cn = "normal iconfont icon-man"
          if (d <= male_ratio) {
            cn += " deep"
          } else if (d - 1 < male_ratio) {
            cn += " light"
          }
          return <span className={cn} key={d} />
        })}
      </div>
      <div className="womanList">
        {[10, 9, 8, 7, 6, 5, 4, 3, 2, 1].map(d => {
          let cn = "normal iconfont icon-woman"
          if (d <= female_ratio) {
            cn += " deep"
          } else if (d - 1 < female_ratio) {
            cn += " light"
          }
          return <span className={cn} key={d} />
        })}
        <span className="num" id="woman-pie">
          {per_female}%
        </span>
      </div>
    </div>
  )
}
